import React from "react";
import { Slider, Row, Col, Alert } from "antd";
import styles from "./selector.module.less";
import Title from "antd/lib/typography/Title";

const SliderLayout = props => {
    const {
        title,
        leftLabel,
        rightLabel,
        value,
        marks,
        max,
        onChange,
        SliderMaxMessage,
        otherProps,
    } = props;
    return (
        <div className={styles.selector}>
            <Title level={3}>{title}</Title>
            <Row
                type="flex"
                justify="space-between"
                align="bottom"
                style={{ padding: "1rem 0.25rem 0" }}
            >
                <Col span={14} style={{ fontSize: "1.5rem" }}>
                    {leftLabel}
                </Col>
                <Col span={10} style={{ textAlign: "right", fontSize: "1.5rem" }}>
                    {rightLabel}
                </Col>
            </Row>
            <Slider
                defaultValue={value}
                value={value}
                marks={marks}
                max={max}
                style={{ marginBottom: "1.5rem" }}
                onChange={onChange}
                tooltipVisible={false}
                {...otherProps}
            />
            {/** what if the slider is at max? */}
            <Alert
                message={SliderMaxMessage}
                type="info"
                style={{
                    display: max - value < 0.01 ? "block" : "none",
                    marginBottom: "1rem",
                }}
            />
        </div>
    );
};

export default SliderLayout;
